export let steps = [

    /*{
        'id': 'demo',
        'title'  : 'WIZARD.CERTIFICAR35.STEPS.STP3.WIZBT',
        'content': '',
        'icon' : 'poll',
        'ruta' : './main-page',
        'tituloPagina': 'WIZARD.CERTIFICAR35.STEPS.STP3.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR35.STEPS.STP3.SUBTI',
        'status' : 1
    },*/
   /* {
        'id': 'enc',
        'title'  : 'WIZARD.CERTIFICAR35.STEPS.STP10.WIZBT',
        'content': '',
        'icon' : 'poll',
        'ruta' : './encuestas-col',
        'tituloPagina': 'WIZARD.CERTIFICAR35.STEPS.STP10.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR35.STEPS.STP10.SUBTI',
        'status' : 1
    },*/

    /*{
        'id': 'colabs',
        'title'  : 'WIZARD.CERTIFICAR35.STEPS.STP5.WIZBT',
        'content': '',
        'icon' : 'people',
        'ruta' : './collaborators35',
        'tituloPagina': 'WIZARD.CERTIFICAR35.STEPS.STP5.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR35.STEPS.STP5.SUBTI',
        'status' : 1
    },*/{
        'id': 'colabs35',
        'title'  : 'WIZARD.CERTIFICAR35.STEPS.STP10.WIZBT',
        'content': '',
        'icon' : 'people',
        'ruta' : './collaborators',
        'tituloPagina': 'WIZARD.CERTIFICAR35.STEPS.STP10.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR35.STEPS.STP10.SUBTI',
        'status' : 1

    },{
        'id': 'prog',
        'title'  : 'WIZARD.CERTIFICAR35.STEPS.STP6.WIZBT',
        'content': '',
        'icon' : 'date_range',
        'ruta' : './schedule',
        'tituloPagina': 'WIZARD.CERTIFICAR35.STEPS.STP6.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR35.STEPS.STP6.SUBTI',
        'status' : 1
    },
    {
        'id': 'envio',
        'title'  : 'WIZARD.CERTIFICAR35.STEPS.STP9.WIZBT',
        'content': '',
        'icon' : 'send',
        'ruta' : './mailSending-nom035',
        'tituloPagina': 'WIZARD.CERTIFICAR35.STEPS.STP9.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR35.STEPS.STP9.SUBTI',
        'status' : 1
    },
    {
        'id': 'cierre',
        'title'  : 'WIZARD.CERTIFICAR35.STEPS.STP8.WIZBT',
        'content': '',
        'icon' : 'power_settings_new',
        'ruta' : './cierre-n35',
        'tituloPagina': 'WIZARD.CERTIFICAR35.STEPS.STP8.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR35.STEPS.STP8.SUBTI',
        'status' : 1
    }
];

export let stepsV3 = [
{
        id: 'colabs35',
        title  : 'WIZARD.CERTIFICAR35.STEPS.STP10.WIZBT',
        videoBanner: 'colaboradores',
        icon : 'people',
        ruta : './collaborators',
        tituloPagina: 'WIZARD.CERTIFICAR35.STEPS.STP10.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR35.STEPS.STP10.SUBTI',
        status : 1

    },
    {
        id: 'programacion',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP6.WIZBT',
        videoBanner: 'programar',
        icon : 'date_range',
        ruta : './schedule',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP6.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP6.SUBTI',
        status : 1,
    },
    {
        id: 'encuesta',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP4-1.WIZBT2',
        videoBanner: 'crear_enc',
        icon : 'list_alt',
        ruta : './crearencuesta',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP4-1.TITULO2',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP4-1.SUBTI',
        status : 1,
    },

    {
        id: 'envio',
        title  : 'WIZARD.CERTIFICAR35.STEPS.STP9.WIZBT',
        videoBanner: 'envio',
        content: '',
        icon : 'send',
        ruta : './mailSending-nom035',
        tituloPagina: 'WIZARD.CERTIFICAR35.STEPS.STP9.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR35.STEPS.STP9.SUBTI',
        status : 1
    },
    {
        id: 'confirmacion',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP9.WIZBT',
        videoBanner: '',
        icon : 'build_circle',
        ruta : './statusSurveys',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP9.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP9.SUBTI',
        status : 1,
    },
    {
        id: 'cierre',
        title  : 'WIZARD.CERTIFICAR35.STEPS.STP8.WIZBT',
        videoBanner: 'cierre',
        icon : 'trending_up',
        ruta : './cierre-n35',
        tituloPagina: 'WIZARD.CERTIFICAR35.STEPS.STP8.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR35.STEPS.STP8.SUBTI',
        status : 1
    }
];
